<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate>
    <div class="card mb-2 wow detalle-cliente">
        <div class="card-body justify-content-between">
            <div class="row mb-0 filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6;">
                <button type="button" mdbBtn color="info" (click)="openModalRedeposito()" size="sm" mdbWavesEffect>
                    Redepósito
                </button>
            </div>
            <div class="row filtros-body align-items-center">
                <div [ngClass]="{'col': true, disabledContent: filtersDisabled}" style="max-width: 150px;">
                    <div class="md-form">
                        <input value="" type="text" id="rutcliente" class="form-control" placeholder="" required
                            #rutcliente formControlName="rutCliente" formatRut />
                        <label for="rutcliente">RUT</label>
                        <div *ngIf="
                                  formHeader.get('rutCliente').invalid &&
                                  (formHeader.get('rutCliente').dirty ||
                                  formHeader.get('rutCliente').touched)
                              ">
                            <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">
                                Ingrese rut cliente
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'col d-flex':true, disabledContent: filtersDisabled}" style="max-width: 300px;">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="openModalSeleccionarClientes()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" style="display: contents;">
                        {{ clienteSeleccionado?.razon_social }}
                    </h6>
                </div>
                <div [ngClass]="{'col':true, disabledContent: filtersDisabled}" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'" required
                            formControlName="fechaDesde">
                        </mdb-date-picker>
                        <div *ngIf="
                              formHeader.get('fechaDesde').invalid &&
                              (formHeader.get('fechaDesde').dirty ||
                              formHeader.get('fechaDesde').touched)
                          ">
                            <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                                Ingrese fecha desde
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'col':true, disabledContent: filtersDisabled}" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
                            formControlName="fechaHasta">
                        </mdb-date-picker>
                        <div *ngIf="
                              formHeader.get('fechaHasta').invalid &&
                              (formHeader.get('fechaHasta').dirty ||
                              formHeader.get('fechaHasta').touched)
                          ">
                            <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                                Ingrese fecha hasta
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <mdb-checkbox (change)="handleCheckTodos($event)">Todos</mdb-checkbox>
                </div>
            </div>
        </div>
        <!-- FOOTER -->
        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
                <mdb-icon fas icon="search"></mdb-icon>
                Buscar
            </button>
        </div>
    </div>
</form>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT_BLO_DESB" (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>

<app-cheques-redeposito-modal-add-edit-redeposito></app-cheques-redeposito-modal-add-edit-redeposito>